export default "__VITE_ASSET__bvJqNY30__"